import { useSelector, useDispatch } from 'react-redux'
import queryString from 'query-string'
import { updateUserSession } from 'actions/userSession'
import { useHistory } from 'react-router-dom'

export default function useStripeConnect(payoutJar) {
  const { location: { pathname }  } = useHistory()
  const { email, firstName, lastName } = useSelector(({ auth: { user } }) => user)

  const dispatch = useDispatch()

  function initiateOAuth() {
    // Generate a random string as `state` to protect from CSRF by matching against state value in redirect
    const state = Math.random().toString(36).slice(2)
    dispatch(updateUserSession({ state: state, referrer: pathname + `?payoutJar=${payoutJar}` }))

    const oAuthParams = {
      redirect_uri: window.location.origin + '/stripe-connect-redirect',
      client_id: process.env.REACT_APP_STRIPE_CLIENT_ID,
      state: state,
      'suggested_capabilities[]': 'transfers',
      'stripe_user[email]': email,
      'stripe_user[first_name]': firstName,
      'stripe_user[last_name]': lastName
    }
    const oAuthQueryParams = queryString.stringify(oAuthParams)
    const oAuthLink = `https://connect.stripe.com/express/oauth/authorize?${oAuthQueryParams}`
    window.location = oAuthLink
  }

  return initiateOAuth
}
